import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

class PatternLibModalComponent extends React.Component {
  constructor(props) {
    super(props);
    this.timeOutCheck = this.timeOutCheck.bind(this);
    this.state = {
      show: this.props.show,
      timeOut: this.props.timeOut,
    };
  }

  componentWillReceiveProps(newProps) {
    // when the props are updated, this method is invoked before the render of the component.
    this.setState({ show: newProps.show, timeOut: newProps.timeOut });
  }

  timeOutCheck() {
    setTimeout(() => {
      this.setState({ show: false }, () => {
        this.props.assignedTagModalCheck();
      });
    }, 5000);
  }

  render() {
    if (this.props.timeOut) {
      this.timeOutCheck();
    }
    return (
      <Modal
        show={this.state.show}
        className={this.props.customClass}
        onHide={this.props.onHide}
        bsSize={this.props.bsSize}
        modalHeading={this.props.modalHeading}
        modalFooter={this.props.modalFooter}
        container={this.props.scope}
      >
        <Modal.Header
          className="c-modal__header"
          closeButton={this.props.closeButton}
        >
          <Modal.Title
            componentClass="h2"
            className="c-modal__title"
            id="contained-modal-title-lg"
          >
            {this.props.modalHeading}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className={
            this.props.modalHeading === '' && this.props.modalFooter === ''
              ? 'c-modal__body'
              : 'c-modal__body c-modal__body--padding'
          }
        >
          <div> {this.props.modalBody} </div>
        </Modal.Body>
        <Modal.Footer className="c-modal__footer">
          {this.props.modalFooter}
        </Modal.Footer>
      </Modal>
    );
  }
}

PatternLibModalComponent.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  bsSize: PropTypes.string,
  modalHeading: PropTypes.string,
  modalBody: PropTypes.string,
  modalFooter: PropTypes.string,
  customClass: PropTypes.string,
  closeButton: PropTypes.bool,
  timeOut: PropTypes.bool,
};

PatternLibModalComponent.defaultProps = {
  show: false,
  onHide() {
    return null;
  },
  bsSize: 'medium',
  modalHeading: '',
  modalBody: '',
  modalFooter: '',
  closeButton: true,
  modalInContainer: false,
  scope: this,
  timeOut: false,
};

export default PatternLibModalComponent;
